import React, { useEffect, useState } from 'react';
import './App.css';
import DefaultLayout from './components/DefaultLayout';
import { IsAuthenticated, prefix, SetCookie } from './components/MojaveLib';
import Login from './views/auth/Login';
import { useTranslation } from 'react-i18next';

const App = () => {

    const [defaultLang, setDefaultLang] = useState('en');
    const { t, i18n } = useTranslation('translation');

    useEffect(() => {
        changeLanguage('en');
    }, [i18n]);

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);

        setDefaultLang(lang);

        SetCookie(`thyme_web_${prefix()}_token`, lang);
    }

    return IsAuthenticated() ?
        <DefaultLayout changeLanguage={changeLanguage} /> :
        <Login changeLanguage={changeLanguage} />;
}

export default App;

